import { render, staticRenderFns } from "./PendingTempReg.vue?vue&type=template&id=68dcb54a"
import script from "./PendingTempReg.vue?vue&type=script&lang=js"
export * from "./PendingTempReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports